import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Horse_show_account_status }  from '../models/accounting/horse_show_account_status';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class AccountStatusService {

  account_list_cache: Horse_show_account_status[] = [];

  constructor(private http: HttpClient) { }

  /**
   * Every horse show the signed-in user has entries at, each carrying its list
   * of entry accounts. The API has no per-horse-show variant of this call - the
   * controller only answers on its index - so callers that want one show filter
   * what comes back here.
   */
  getUserList() : Promise<Horse_show_account_status[]>  {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'accounting/account_status_controller/').subscribe((response:any) => {
      if(response.type == 'horse_show_account_status' && response.data){

        this.account_list_cache = response.data;

        resolve(response.data);
      } else {
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
  });
  }

  getCachedList(): Horse_show_account_status[] {
    return this.account_list_cache;
  }

  resetCache(): void {
    this.account_list_cache = [];
  }

}
